export enum SequencePreviewMode {
  ROW = 0,
  TILE = 1,
}
